<template>
  <el-container  style="display: block;">

    <el-row  class="tui-el"  style="margin-top: 20px;margin-left: 3%;">
      <el-row :span="2" style="margin-top: 30px;">
          <el-input v-model="seachName" style="width: 150px;" placeholder="请输入搜索词"></el-input>
          <el-select v-model="groupNameg" @change="loadList()"  filterable placeholder="请选择分组" >
              <el-option
                v-for="item in groupName"
                :key="item.gname"
                :label="item.gname"

                :value="item.gname">
              </el-option>
            </el-select>
          <el-button type="primary" style="background-color: #409eff;" @click="seach()" round>搜索</el-button>
          <el-button type="primary" style="background-color: #409eff;" @click="tongbu()" round>一键同步模型</el-button>
      </el-row>

        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 100%;margin-left: 0;height: 800px;text-align: center;">
            <el-table-column

              width="100"
              label="组名"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.gname}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="200"
              label="名称"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.name}}</div>
               </template>
            </el-table-column>

          	<el-table-column

              width="250"
          	  label="图片查看\修改"
          	   >
              <template slot-scope="scope">

                <el-row v-if="scope.row.img_s == 0">

                  <el-col :span="20" style="text-align: center;margin-top: 20px;" @click.native="seeImg(scope.$index,scope.row)">
                    查看图片

                  </el-col>





                </el-row>
                <el-row v-if="scope.row.img_s == 1">

                  <img v-if="scope.row.img" :src="scope.row.img" class="avatar">





                </el-row>
              </template>
          	</el-table-column>

            <el-table-column

              width="200"
              label="操作"
               >
               <template slot-scope="scope">
                 <el-row>
                   <el-button type="primary" style="background-color: #409eff;" @click.native="duoweitongbu(scope.row.id)" round>同步</el-button>

                 </el-row>
               </template>
            </el-table-column>
            <!-- <el-table-column

              width="200"
              label="导入视频库"
               >
               <template slot-scope="scope">
                 <el-row>
                   <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="move(scope.row.id)">导入</el-col>

                 </el-row>
               </template>
            </el-table-column> -->
            </el-table>
          </template>
          <div class="page">
          	<el-pagination
          	  @size-change="loadList()"
          	  @current-change="loadList()"
          	  :current-page.sync="page"
          	  :page-size="10"
          	  background
          	  layout="total,prev, pager, next, jumper"
          	  :total="count">
          	</el-pagination>
          </div>
        </el-row>






    </el-row>


    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      >
      <span>确认删除？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doDell()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="disDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="disName"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="dodisChange()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="disDialogVisibleshi"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="disNameshi"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisibleshi = false">取 消</el-button>
    	<el-button type="primary" @click="dodisChangeshi()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<style>
  th div{
    text-align: center;
  }
</style>
<script>

  export default {
    data() {
       return {
         page:1,
         count:0,
        options: [],
        delId:'',
        delIndex:'',
        dialogVisible:false,
        value: '',
        addImg:'',
        addImgs:'',
        newName:'',
        imageId: 0,
        list: [],
        search:'',
        w:0,
        h:0,
        chi:0,
        disName:'',
        disNameshi:'',

        disDialogVisible:false,
        disDialogVisibleshi:false,
        disId:0,
        disIdshi:0,
        seachName:'',
        gName:'',
        groupName:'',
        groupNameg:'',
        url:'无',
        zhiling:'无',
        urlmp4:'无',
        news:'无',
        music:'无',
        shiping:'无',
        bgm:'无',
        goods:'无',
        baike:'无',
        musiczhiling:'无'

      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadList();
      var lett = this;
       document.onkeydown = function(e) {
       var key = window.event.keyCode;
       if (key == 13) {
         lett.seach();
       }
      }
    },

	methods:{
    seeImg(index,row){
      row['img_s'] = 1
      // this.list[index]['img_s'] = 1;
      this.$set(this.list,index,row);
      // console.log(this.list[index]['img_s'])
      // this.$forceUpdate()


    },
    seach(){
      this.loadList();
    },
    duoweitongbu(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
          id:id
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/imageDuoweiTongbu'
      })
      .then(res=>{
      	if(res.data.code == 200){

           this.$message({
           	type: 'success',
           	message: '同步成功'
           });
           this.loadList()

      	}else{
          this.$message({
          	type: 'error',
          	message: '操作失败'
          });
      	}

      })
      .catch(err=>{

      });
    },
    tongbu(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/imageTongbu'
      })
      .then(res=>{
      	if(res.data.code == 200){

           this.$message({
           	type: 'success',
           	message: '同步成功'
           });
           this.loadList()

      	}else{
          this.$message({
          	type: 'error',
          	message: '操作失败'
          });
      	}

      })
      .catch(err=>{

      });
    },
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          p:this.page,
          gname:this.groupNameg
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementdtNewB'
      })
      .then(res=>{
        this.groupName = res.data.group;
        this.list = res.data.list;
        this.list.forEach(function(item, index) {
              item['img_s'] = 0;
        })

        this.count = res.data.count;
      	// this.list = res.data;

      })
      .catch(err=>{

      });
    },


    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .tui-content{
    margin-left: 24%;
    margin-top: 100px;
  	width: 100%;
  	height: 100%;
  }
  .tui-el{
    width: 80%;
  }
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
    }
    .avatar {
      width: 60px;
      height: 60px;
      display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/main/elementdtb.vue